"use client";

import { useEffect, useRef } from "react";
import { useInView, animate } from "framer-motion";

type AnimatedNumberProps = {
  value: number;
};

export default function AnimatedNumber({ value }: AnimatedNumberProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true });

  useEffect(() => {
    if (inView && ref.current) {
      const controls = animate(0, value, {
        duration: 2,
        onUpdate(latest) {
          if (ref.current) {
            ref.current.textContent =
              Math.round(latest).toLocaleString("en-US");
          }
        },
      });
      return () => controls.stop();
    }
  }, [inView, value]);

  return (
    <span ref={ref} style={{ fontSize: 48, fontWeight: 800 }}>
      0
    </span>
  );
}
